import Lightbox from './lightbox';
import zoom from './zoom';
import { BREAKPOINT, FORCE_MOBILE, ZOOM_SELECTOR } from './constants';

class Zoom {
  public constructor(carousel: HTMLElement) {
    this.carousel = carousel;
  }

  private readonly carousel: HTMLElement;

  public readonly init = (): void => {
    this.initZoom();
    window.addEventListener('resize', this.initZoom);
  };

  private readonly initZoom = (): void => {
    const elements = this.carousel.querySelectorAll(
      ZOOM_SELECTOR,
    ) as NodeListOf<HTMLElement>;
    if (elements.length) {
      const lightbox = new Lightbox(this.getZoomClassName(elements));
      if (this.isMobileForced() || window.innerWidth < BREAKPOINT) {
        lightbox.unset();
        zoom.init(elements);
      } else {
        zoom.unset(elements);
        lightbox.init();
      }
    }
  };

  private readonly getZoomClassName = (
    elements: NodeListOf<HTMLElement>,
  ): string => elements.item(0).classList.item(0) as string;

  private readonly isMobileForced = (): boolean => {
    if (!this.carousel.parentElement) return false;
    return this.carousel.parentElement.classList.contains(FORCE_MOBILE);
  };
}

export default Zoom;
